import React, { Component, Fragment } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import BullSeparator from 'components/BullSeparator';
import { translate } from 'components/translate';
import ClubDate from 'helpers/ClubDate';
import DateHelper, { shortFormatDate } from 'helpers/Date';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';

import './CommentHeaderStatus.scss';

const pendingStatus = 'PENDING';
const topicType = 'TOPIC';

@translate()
@inject((stores) => ({
  locale: stores.UserStore.shortLocale
}))
@observer
export default class CommentHeaderStatus extends Component {
  static propTypes = {
    className: PropTypes.string,
    t: PropTypes.func,
    item: PropTypes.object,
    locale: PropTypes.string,
    showStatus: PropTypes.bool,
    showTopic: PropTypes.bool,
    showUsernameEmail: PropTypes.string,
    pendingHighlight: PropTypes.bool
  };

  static defaultProps = {
    showTopic: true,
    pendingHighlight: false
  };

  get classes() {
    const { className } = this.props;

    return classNames(
      '_d-inline-flex _d-flex-row _overflow-hidden _text-black _align-items-center',
      className
    );
  }

  getAction = (type) => {
    const { t } = this.props;

    return type === topicType
      ? t('community.actions.topic')
      : t('community.actions.answer');
  };

  getCommentStatus(status) {
    const { t } = this.props;

    const statuses = {
      PENDING: 'community.comments_status.pending',
      APPROVED: 'community.comments_status.approved',
      SPAM_CONFIRMED: 'community.comments_status.spam',
      DISAPPROVED: 'community.comments_status.disapproved',
      AWAITING_MODERATION: 'community.comments_status.not_reviewed'
    };

    return t(statuses[status]);
  }

  getPostDate(item) {
    const { t } = this.props;
    const label =
      item.lastAction === 'POST' ? 'community.post_at' : 'community.edit_at';

    return t(label, {
      date: DateHelper.formatDate(item.commentDate, shortFormatDate)
    });
  }

  isPending = (status) => status === pendingStatus;

  // #region render

  renderDate() {
    const { item, showTopic, pendingHighlight } = this.props;

    return (
      <Fragment>
        <BullSeparator
          className={classNames('_text-gray-400 _d-none _mx-2', {
            '_d-sm-inline-block': showTopic,
            '_d-md-inline-block': !showTopic
          })}
        />
        <span
          className={classNames('_d-inline-block _w-full _text-gray-400', {
            '_w-sm-auto': showTopic,
            '_w_md-auto': !showTopic,
            '_font-weight-bold': pendingHighlight && this.isPending(item.status)
          })}
        >
          {this.getPostDate(item)}
        </span>
      </Fragment>
    );
  }

  renderTimelapse(item, locale) {
    return (
      <div className="_d-none _d-xl-inline-block">
        <BullSeparator className="_text-gray-400 _mx-2" />
        <span className="_d-inline-block _text-gray-400">
          {ClubDate.distanceInWordsToNow(item.commentDate, {
            addSuffix: true,
            locale: ClubDate.locales[locale]
          })}
        </span>
      </div>
    );
  }

  render() {
    const {
      item,
      locale,
      showStatus,
      showTopic,
      showUsernameEmail,
      pendingHighlight
    } = this.props;

    return (
      <div className={this.classes}>
        <FontAwesomeIcon
          icon={['fal', 'message']}
          className={classNames('_mr-2 _d-flex-shrink-0', {
            '_d-none': !showTopic
          })}
        />

        <div className="_d-flex _flex-column _flex-md-row _d-flex-wrap _d-flex-grow _line-height-lg">
          {showTopic && (
            <span className="_d-inline-block _font-weight-bold">
              {this.getAction(item.type)}
            </span>
          )}

          {showUsernameEmail && (
            <Fragment>
              <BullSeparator
                className={classNames({
                  '_d-none': !showTopic,
                  '_d-inline-block _mx-2': showTopic
                })}
              />
              <span
                className="comment-username _d-inline-block tw-truncate _font-weight-bold"
                title={`${showUsernameEmail || ''}`}
              >
                {showUsernameEmail}
              </span>
            </Fragment>
          )}
          {(showTopic || showStatus) && (
            <Fragment>
              <BullSeparator
                className={classNames('_mx-2', {
                  '_d-none _d-xl-inline-block': !showTopic
                })}
              />
              <span
                className={classNames({
                  '_d-none _d-xl-inline-block': !showTopic,
                  '_d-inline-block': showTopic,
                  '_font-weight-bold':
                    pendingHighlight && this.isPending(item.status)
                })}
                data-test="comment-status"
              >
                {this.getCommentStatus(item.status)}
              </span>
            </Fragment>
          )}

          {this.renderDate()}

          {this.renderTimelapse(item, locale)}
        </div>
      </div>
    );
  }

  // TODO a área comentada deverá ficar disponível assim que o backend for liberado
  // renderTimelapse(item, locale) {
  //   return (
  //     <div className={`${topicAnswerClass}--inline ${topicAnswerClass}__timelapse`}>
  //       <div className={`${topicAnswerClass}__separator ${topicAnswerClass}__separator--hide`} />
  //       {
  //         ClubDate.distanceInWordsToNow(
  //           ClubDate.convertUTCDateToLocalDate(item.commentDate),
  //           { addSuffix: true, locale: ClubDate.locales[locale] }
  //         )
  //       }
  //     </div>
  //   );
  // }

  // #endregion
}
